const zhCN = {
  userCenter: '个人中心',
  loginOut: '退出登录',
  loginOutFail: '退出失败！'
}
const enUS = {
  userCenter: 'User Center',
  loginOut: 'Logout',
  loginOutFail: 'Logout failed!'
}

export default { zhCN, enUS }